import { render, staticRenderFns } from "./centerMemberTag.vue?vue&type=template&id=744ffb31&scoped=true&"
import script from "./centerMemberTag.vue?vue&type=script&lang=js&"
export * from "./centerMemberTag.vue?vue&type=script&lang=js&"
import style0 from "./centerMemberTag.vue?vue&type=style&index=0&id=744ffb31&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "744ffb31",
  null
  
)

export default component.exports